// `_map` : a collection's function
// -------------------------------------

// The cornerstone, a `map` implementation, aka `collect`.
export {default} from './collect';